import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent, { dialogContentClasses, DialogContentProps } from '@mui/material/DialogContent';
import Grid, { gridClasses, GridProps } from '@mui/material/Grid';
import IconButton, { iconButtonClasses, IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import LinkButton, { ILinkButtonProps } from '~/components/LinkButton';
import { AVATAR_SIZE } from '~/layouts/ExamineeLayout/styles';
import { HEIGHT_HEADER } from '~/layouts/RoomCodeLayout/styles';
export const StyledDialogContent = styled(DialogContent)<DialogContentProps>({
  [`&.${dialogContentClasses.root}`]: {
    alignItems: 'center',
    display: 'flex'
  }
});
export const StyledIconButton = styled(IconButton)<IconButtonProps>(({
  theme
}) => ({
  [`&.${iconButtonClasses.root}`]: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(1)
  }
}));
export const StyledGridContainer = styled(Grid)<GridProps>(({
  theme
}) => ({
  [`&.${gridClasses.container}`]: {
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
    width: 'auto'
  }
}));
export const StyledSignOutButton = styled(LinkButton)<ILinkButtonProps>(({
  theme
}) => ({
  color: theme.palette.error.dark
}));
export const StyledDialog = styled(Dialog)<DialogProps>({
  [`& .MuiPaper-root`]: {
    marginRight: AVATAR_SIZE + 1 / 3 * AVATAR_SIZE,
    marginTop: 0,
    position: 'fixed',
    right: 0,
    top: HEIGHT_HEADER
  }
});